import React from 'react';
import { observer } from 'mobx-react-lite';

import './style.sass';

import { LoginForm } from 'app/components/LoginForm';
import { LoginPageViewModel } from 'app/viewModels/pages/LoginPageViewModel';
import { useModel } from 'app/hooks/useViewModel';
import { Page } from 'app/components/common/PageLayout';


export const LoginPage = observer(() => {
    const {
        submitLoginForm,
        nagivateToTheSignup,
        navigateToTheResetPassword,
        signInWithGoogle,
        signInWithApple,
        isLoading,
    } = useModel(LoginPageViewModel);

    return (
        <Page className="login-page" isLoading={isLoading}>
            <div className="text-block">
                <h1 className="login-page__title title-h1 dark-violet">Sign in to Explicit</h1>
                <p className="login-page__desc p2-medium grey-1">Welcome back! Please choose the sign in method.</p>
            </div>

            <LoginForm
                onSubmit={submitLoginForm}
                onClickSignup={nagivateToTheSignup}
                onClickResetPassword={navigateToTheResetPassword}
                onClickGoogleAuth={signInWithGoogle}
                onClickAppleAuth={signInWithApple}
            />
        </Page>
    );
});
